<template>
    <b-row class="py-5">
        <b-col cols="12" v-if="descuento_aplicado > 0">
            <h4>Te recordamos que el saldo restante que tienes en tu cuenta, es de {{ saldo_restante }}.</h4>
            <b-alert show variant="success" class="text-center">
                <h3>¡Descuento aplicado!</h3>
            </b-alert>    
            <button class="button large-button" @click="cancelarDescuento">Cancelar descuento</button>
        </b-col>
        <b-col cols="12" class="mt-3" v-else>
            <h3>Tu cuenta tiene un saldo de {{ saldo_disponible }} en tu monedero.</h3>
            <h5>¿Quieres gastarlo y obtener un descuento por la renovación?</h5>
            <label class="mt-3" for="range-1">Seleccione el importe que quieres gastar como descuento.</label>
            <b-form-input id="range-1" v-model="descuento" type="range" min="0" :max="maximo_descuento" step="0.01"></b-form-input>
            <div class="mt-2">
                <span class="h4">{{ descuento }}</span>
                <button class="button large-button ml-4" @click.prevent="confirmar">Confirmar</button>
            </div>
        </b-col>        
    </b-row>
</template>

<script>
export default {
    props: {
        'saldo_disponible': {
            required: true,
            type: Number
        },
        'importe': {
            required: true,
            type: Number
        },
        'descuento_aplicado' : {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            descuento: 0
        }
    },
    computed: {
        maximo_descuento() {
            if(this.importe < this.saldo_disponible) {
                return this.importe;
            } else {
                return this.saldo_disponible;
            }
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        saldo_restante() {
            return this.saldo_disponible - this.descuento_aplicado;
        }
    },
    methods: {
        confirmar() {
            this.$emit('confirmado', this.descuento);
        },
        cancelarDescuento() {
            this.$emit('cancelar');
        }
    }
}
</script>